import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Me } from "../api/users";
import { PostGet } from "../api/post";
import { DirectorLevel, KADRLevel } from "../constants";

const REPORT_SECTIONS = [
  {
    title: "Согласования и операции",
    items: [
      {
        to: "/report-food",
        title: "Отчет по еде",
        description: "Учет приема пищи сотрудниками",
      },
      {
        to: "/report-approve-mng",
        title: "Отчет по согласованию МНГ",
        description: "Статус согласований менеджеров",
      },
      {
        to: "/report-service-notes",
        title: "Служебные записки",
        description: "Изменения расписания ЧК после согласования ТУ",
        minLevel: DirectorLevel,
      },
      {
        to: "/report-approve-chk",
        title: "Отчет по согласованию ЧК",
        description: "Статус согласований чеклистов",
      },
      {
        to: "/report-FT",
        title: "Отчет по FT",
        description: "Данные по full-time сотрудникам",
      },
    ],
  },
  {
    title: "Смены",
    items: [
      {
        to: "/report-shifts",
        title: "Отчет по сменам",
        description: "Расписание и отработанные смены",
      },
      {
        to: "/report-nmg-shedule-only-directors",
        title: "Отчет МНГ по сменам директоров",
        description: "Смены директоров в разрезе МНГ",
      },
    ],
  },
  {
    title: "Мотивация",
    items: [
      {
        to: "/reports-motivation",
        title: "Отчет по мотивации",
        description: "Показатели и премии сотрудников",
        minLevel: 12,
      },
      {
        to: "/reports-motivationMNG",
        title: "Отчет по мотивации МНГ",
        description: "Мотивация менеджеров",
        minLevel: 12,
      },
    ],
  },
  {
    title: "Прочее",
    items: [
      {
        to: "/report-deployment-accuracy",
        title: "Точность попадания в деплоймент",
        description: "Сравнение плановых часов смен и факта по отметкам",
        minLevel: DirectorLevel,
      },
      {
        to: "/report-payroll",
        title: "Расчёт ЗП",
        description: "Оплата по отметкам Boss Control в рамках смен",
        minLevel: 40,
      },
      {
        to: "/report-energy",
        title: "Отчет по электроэнергии",
        description: "Потребление электроэнергии",
        minLevel: 20,
      },
      {
        to: "/report-z",
        title: "Z-отчёт (OFD)",
        description: "Нал и безнал смены по дате открытия, за вычетом возвратов",
        minLevel: 20,
      },
      {
        to: "/report-dashboard",
        title: "Дашборд",
        description: "Ежедневные показатели отделов",
        minLevel: KADRLevel,
      },
      {
        to: "/report-employee",
        title: "Табель учёта рабочего времени",
        description: "План, факт Boss Control и отклонения по сменам",
        minLevel: DirectorLevel,
      },
    ],
  },
];

const Reports = ({ token }) => {
  const [access_level, setAccessLevel] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const user = await Me(token);
      const PostData = await PostGet(token, user.post_id);
      setAccessLevel(PostData.access_level);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  const visibleSections = REPORT_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(
      (item) => access_level >= (item.minLevel ?? 0),
    ),
  })).filter((section) => section.items.length > 0);

  return (
    <div className="reports-page">
      <div className="reports-header">
        <div>
          <h1>Отчёты</h1>
          <p className="reports-hint">
            Выберите отчёт — доступные разделы зависят от вашей должности
          </p>
        </div>
        <Link to="/profile" className="reports-back-link">
          ← К профилю
        </Link>
      </div>

      {loading ? (
        <div className="reports-loading">
          <div className="spinner-border profile-spinner" role="status">
            <span className="visually-hidden">Загрузка...</span>
          </div>
          <p>Загрузка отчётов...</p>
        </div>
      ) : visibleSections.length === 0 ? (
        <div className="reports-empty">
          Нет доступных отчётов для вашего уровня доступа
        </div>
      ) : (
        visibleSections.map((section) => (
          <section key={section.title} className="reports-section">
            <h2 className="reports-section-title">{section.title}</h2>
            <div className="reports-grid">
              {section.items.map((item) => (
                <Link key={item.to} to={item.to} className="report-card-link">
                  <article className="report-card">
                    <div className="report-card-accent" />
                    <div className="report-card-body">
                      <h3 className="report-card-title">{item.title}</h3>
                      <p className="report-card-text">{item.description}</p>
                      <span className="report-card-action">Открыть →</span>
                    </div>
                  </article>
                </Link>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
};

export default Reports;
